import Image from 'next/image'
import Link from 'next/link'
import { ArrowDownRight, ArrowUpRight } from '@phosphor-icons/react/dist/ssr'
import branoPortrait from '../../public/brano_2.webp'
import CTAButton from './CTAButton'

interface HeroSectionProps {
  title: string | React.ReactNode
  subtitle: string
  showCTA?: boolean
  ctaHref?: string
  ctaText?: string
  className?: string
  showPortrait?: boolean
}

export default function HeroSection({ title, subtitle, showCTA = false, ctaHref = '/contact', ctaText = 'Book a call', className = '', showPortrait = false }: HeroSectionProps) {
  return (
    <section className={`portfolio-hero ${showPortrait ? 'portfolio-hero--portrait' : ''} ${className}`}>
      <div className="portfolio-container hero-layout">
        <div className="hero-copy">
          <p className="hero-intro">{showPortrait ? 'Hi, I’m Braňo. Your analytics partner.' : 'Independent web analytics specialist'}</p>
          <h1>{title}</h1>
          <p className="hero-description">{subtitle}</p>
          {showCTA && (
            <div className="hero-actions">
              <CTAButton href={ctaHref} size="lg" variant="filled">{ctaText}<ArrowUpRight size={19} aria-hidden="true" /></CTAButton>
              {showPortrait && <Link href="/case-studies" className="portfolio-text-link">Explore my work <ArrowDownRight size={19} aria-hidden="true" /></Link>}
            </div>
          )}
        </div>
        {showPortrait && (
          <Link href="/about" className="hero-portrait" aria-label="Learn more about Branislav Mateas">
            <Image src={branoPortrait} alt="Branislav Mateas in an outdoor arcade" fill loading="eager" fetchPriority="high" placeholder="blur" sizes="(max-width: 767px) 90vw, (max-width: 1023px) 40vw, 390px" className="object-cover object-[50%_43%]" />
          </Link>
        )}
      </div>
    </section>
  )
}
